import { rest } from 'msw'
export default [
  /**
   * マイページログイン
   */
  rest.post('/api/v2/mypage_login', (req, res, ctx) => {
    // Persist user's authentication in the session
    return res(
      ctx.status(200),
      ctx.json({
        error: {
          errorCode: 0,
          errorMessage: '',
          errorMessageDetail: '',
        },
        data: {
          accessToken:
            'mrF6nSSl2bak0cZJSnBZXdcR7xg0xkjfoHHNKqeSssffj6LYzoGTqOD1PdlAK1NISJEf2pqm2Fq1F6BZb3P9vcXoGUq6t3ouUWgNoFCtfqSbmHhqK1WIw4hYj...',
          refreshToken:
            'HNKqeSssffj6LYzoGTqOD1PdlAK1NISJEf2pqm2Fq1F6BZb3P9vcXoGUq6t3ouUWgNoFCtfqSbmHhqK1WIw4mrF6nSSl2bak0cZJSnBZXdcR7xg0xkjfoHhYj...',
          user: {
            appNo: '7418-8525-1638',
            impressionKey: '581fd5fa8244497f978bd26c0a03000a',
            hasMailAddress: 0,
          },
          responseTime: '915148799',
        },
      })
    )
  }),
  /**
   * アプリログイン
   */
  rest.get('/api/v2/app_login', (req, res, ctx) => {
    // Persist user's authentication in the session
    return res(
      ctx.status(200),
      ctx.json({
        error: {
          errorCode: 0,
          errorMessage: '',
          errorMessageDetail: '',
        },
        data: {
          chainId: 1,
          chainName: 'ボーナス',
          serviceName: 'デジタルポイントプラス',
          serviceFullName: 'デジタルポイントプラス by Myトク',
          serviceLogo:
            'https://content.retailstudio.jp/images/0001/service_logo.jpg',
          tutorialPattern: 0,
          callName: 'ing・fanカード コールセンター',
          callTel: '0120-xxxx-xxxx',
          callMail: '',
          callUrl: '',
        },
        user: {
          userId: '5808c2f9-8090-478c-8a12-72d30a03000a',
          displayCardNo: 'xxxx xxxxx xxxx 1234',
          appNo: '7418-8525-1638',
          impressionKey: '581fd5fa8244497f978bd26c0a03000a',
        },
        card: {
          cardName: 'Ing・fanカード',
          cardNoSample: 'XXXX XXXX XXXX',
          cardNoLength: 12,
        },
        responseTime: '1562309754',
      })
    )
  }),
  /**
   * LINEログインURL情報
   */
  rest.post('/api/v2/line_get_login_url', (req, res, ctx) => {
    // Persist user's authentication in the session
    return res(
      ctx.status(200),
      ctx.json({
        error: {
          errorCode: 0,
          errorMessage: 'ユーザ登録エラー',
          errorMessageDetail: '既に登録済みのメールアドレスです',
        },
        url:
          'https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=1234567890&redirect_uri=https%3A%2F%2Fexample.com%2Fauth&state=12345abcde&scope...',
        responseTime: 915148799,
      })
    )
  }),
  /**
   * LINEログインURL情報
   */
  rest.post('/api/v2/line_login', (req, res, ctx) => {
    // Persist user's authentication in the session
    return res(
      ctx.status(200),
      ctx.json({
        error: {
          errorCode: 0,
          errorMessage: 'ユーザ登録エラー',
          errorMessageDetail: '既に登録済みのメールアドレスです',
        },
        accessToken:
          'mrF6nSSl2bak0cZJSnBZXdcR7xg0xkjfoHHNKqeSssffj6LYzoGTqOD1PdlAK1NISJEf2pqm2Fq1F6BZb3P9vcXoGUq6t3ouUWgNoFCtfqSbmHhqK1WIw4hYj',
        refleshToken:
          'HNKqeSssffj6LYzoGTqOD1PdlAK1NISJEf2pqm2Fq1F6BZb3P9vcXoGUq6t3ouUWgNoFCtfqSbmHhqK1WIw4mrF6nSSl2bak0cZJSnBZXdcR7xg0xkjfoHhYj',
        user: {
          appNo: '7418-8525-1638',
          impressionKey: '581fd5fa8244497f978bd26c0a03000a',
          hasMailAddress: 1,
        },
        accounts: [
          {
            linkageId: 1,
            linkageName: 'LINE',
            isLinked: 1,
            linkKey: '123456789012',
          },
        ],
        responseTime: 915148799,
      })
    )
  }),
  /**
   * ログイン認証
   */
  rest.post('/api/v2/login', (req, res, ctx) => {
    // Persist user's authentication in the session
    return res(
      ctx.status(200),
      ctx.json({
        error: {
          errorCode: 0,
          errorMessage: '',
          errorMessageDetail: '',
        },
        data: {
          accessToken:
            'mrF6nSSl2bak0cZJSnBZXdcR7xg0xkjfoHHNKqeSssffj6LYzoGTqOD1PdlAK1NISJEf2pqm2Fq1F6BZb3P9vcXoGUq6t3ouUWgNoFCtfqSbmHhqK1WIw4hYj...',
          refleshToken:
            'HNKqeSssffj6LYzoGTqOD1PdlAK1NISJEf2pqm2Fq1F6BZb3P9vcXoGUq6t3ouUWgNoFCtfqSbmHhqK1WIw4mrF6nSSl2bak0cZJSnBZXdcR7xg0xkjfoHhYj...',
          user: {
            appNo: '7418-8525-1638',
            impressionKey: '581fd5fa8244497f978bd26c0a03000a',
            hasMailAddress: 1,
          },
          accounts: [
            {
              linkageId: 1,
              linkageName: 'LINE',
              isLinked: 1,
              linkKey: '123456789012',
            },
            {},
            {},
          ],
          responseTime: '915148799',
        },
      })
    )
  }),
  /**
   * トークンリフレッシュ
   */
  rest.post('/api/v2/refresh_token', (req, res, ctx) => {
    // Persist user's authentication in the session
    return res(
      ctx.status(200),
      ctx.json({
        error: {
          errorCode: 0,
          errorMessage: '',
          errorMessageDetail: '',
        },
        data: {
          accessToken:
            '2rF6nSSl2bak0cZJSnBZXdcR7xg0xkjfoHHNKqeSssffj6LYzoGTqOD1PdlAK1NISJEf2pqm2Fq1F6BZb3P9vcXoGUq6t3ouUWgNoFCtfqSbmHhqK1WIw4hYj...',
          refleshToken:
            '3NKqeSssffj6LYzoGTqOD1PdlAK1NISJEf2pqm2Fq1F6BZb3P9vcXoGUq6t3ouUWgNoFCtfqSbmHhqK1WIw4mrF6nSSl2bak0cZJSnBZXdcR7xg0xkjfoHhYj...',
          responseTime: '915148799',
        },
      })
    )
  }),
]
